export class GrupoServicoEntity {
  ativado = true;
  descricao = null;

  constructor(grupoServico) {
    if (grupoServico.ativado === false) {
      this.ativado = false;
    }
    this.descricao = grupoServico.descricao;
  }
}
